var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _circle, _circle2, _rect2, _rect3, _circle3, _circle4, _rect4, _path12, _path13, _rect5, _circle5, _circle6, _rect6, _rect7, _circle7, _circle8, _rect8, _path14, _path15, _rect9, _circle9, _circle10, _rect10, _rect11, _circle11, _circle12, _rect12, _path16, _path17, _rect13, _circle13, _circle14, _rect14, _rect15, _circle15, _circle16, _rect16, _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyMultiChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 165,
    viewBox: "0 0 288 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.998 2V9.98347",
    stroke: "#D0D5DD",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M207.998 20.6281V28.6115",
    stroke: "#D0D5DD",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M194.664 15.3058H202.664",
    stroke: "#D0D5DD",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M213.331 15.3058H221.331",
    stroke: "#D0D5DD",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6647 141.711V147.033",
    stroke: "#D0D5DD",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6647 157.678V163",
    stroke: "#D0D5DD",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9971 152.355H53.3304",
    stroke: "#D0D5DD",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.998 152.355H69.3314",
    stroke: "#D0D5DD",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.108 129.735H57.8616C52.9987 129.735 49.0566 125.565 49.0566 120.421C49.0566 115.277 52.9987 111.107 57.8616 111.107H8.80502C3.94214 111.107 0 106.937 0 101.793C0 96.6493 3.94214 92.4793 8.80502 92.4793H59.1194C63.9823 92.4793 67.9245 88.3092 67.9245 83.1652C67.9245 78.0212 63.9823 73.8512 59.1194 73.8512H27.6729C22.81 73.8512 18.8679 69.6811 18.8679 64.5371C18.8679 59.3931 22.81 55.2231 27.6729 55.2231H77.9873C73.1245 55.2231 69.1823 51.053 69.1823 45.909C69.1823 40.765 73.1245 36.595 77.9873 36.595H149.685C154.548 36.595 158.49 40.765 158.49 45.909C158.49 51.053 154.548 55.2231 149.685 55.2231H230.188C235.051 55.2231 238.993 59.3931 238.993 64.5371C238.993 69.6811 235.051 73.8512 230.188 73.8512H257.861C262.724 73.8512 266.666 78.0212 266.666 83.1652C266.666 88.3092 262.724 92.4793 257.861 92.4793H233.962C231.216 92.4793 228.764 93.8086 227.149 95.8921H239.246C241.872 95.8921 244 98.4432 244 101.59C244 104.737 241.872 107.288 239.246 107.288H226.852C228.454 109.604 231.042 111.107 233.962 111.107H241.509C246.372 111.107 250.314 115.277 250.314 120.421C250.314 125.565 246.372 129.735 241.509 129.735H230.694C230.185 129.959 229.635 130.08 229.061 130.08H201.901C204.526 130.08 206.654 132.632 206.654 135.779C206.654 138.925 204.526 141.477 201.901 141.477L163.197 141.477C160.572 141.477 158.444 138.925 158.444 135.778C158.444 132.632 160.572 130.08 163.197 130.08H119.74C119.167 130.08 118.617 129.959 118.108 129.735ZM288 120.421C288 125.565 283.821 129.736 278.666 129.736C273.512 129.736 269.333 125.565 269.333 120.421C269.333 115.277 273.512 111.107 278.666 111.107C283.821 111.107 288 115.277 288 120.421Z",
    fill: "#D0D5DD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1631 27.8943C71.1631 26.3755 72.3943 25.1443 73.9131 25.1443H125.102C126.62 25.1443 127.852 26.3755 127.852 27.8943V79.7632C127.852 81.282 126.62 82.5132 125.102 82.5132H73.9131C72.3943 82.5132 71.1631 81.282 71.1631 79.7632V27.8943Z",
    fill: "white",
    stroke: "#98A2B3",
    strokeWidth: 2.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.0312 33.0172C76.0312 31.3604 77.3744 30.0172 79.0312 30.0172H119.974C121.631 30.0172 122.974 31.3604 122.974 33.0172V67.1566C122.974 68.8135 121.631 70.1566 119.974 70.1566H79.0312C77.3744 70.1566 76.0312 68.8135 76.0312 67.1566V33.0172Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 74.6758,
    y: 30.6975,
    width: 38.3033,
    height: 7,
    fill: "#EAECF0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 119.979,
    cy: 33.6975,
    r: 3,
    fill: "#EAECF0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.6758,
    cy: 46.5582,
    r: 3,
    fill: "#EAECF0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 84.6758,
    y: 43.5582,
    width: 38.3033,
    height: 7,
    fill: "#EAECF0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 74.6758,
    y: 56.4188,
    width: 38.3033,
    height: 7,
    fill: "#EAECF0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.979,
    cy: 59.4188,
    r: 3,
    fill: "#EAECF0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.6758,
    cy: 72.2795,
    r: 3,
    fill: "#EAECF0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 84.6758,
    y: 69.2795,
    width: 38.3033,
    height: 7,
    fill: "#EAECF0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8584 92.8618C77.8584 91.343 79.0896 90.1118 80.6084 90.1118H131.797C133.316 90.1118 134.547 91.343 134.547 92.8618V144.731C134.547 146.25 133.316 147.481 131.797 147.481H80.6084C79.0896 147.481 77.8584 146.25 77.8584 144.731V92.8618Z",
    fill: "white",
    stroke: "#98A2B3",
    strokeWidth: 2.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.7275 97.9847C82.7275 96.3279 84.0707 94.9847 85.7275 94.9847H126.67C128.327 94.9847 129.67 96.3279 129.67 97.9847V132.124C129.67 133.781 128.327 135.124 126.67 135.124H85.7275C84.0707 135.124 82.7275 133.781 82.7275 132.124V97.9847Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3711,
    y: 95.6652,
    width: 38.3033,
    height: 7,
    fill: "#EAECF0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.675,
    cy: 98.6652,
    r: 3,
    fill: "#EAECF0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.3711,
    cy: 111.526,
    r: 3,
    fill: "#EAECF0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 91.3711,
    y: 108.526,
    width: 38.3033,
    height: 7,
    fill: "#EAECF0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3711,
    y: 121.386,
    width: 38.3033,
    height: 7,
    fill: "#EAECF0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.675,
    cy: 124.386,
    r: 3,
    fill: "#EAECF0"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.3711,
    cy: 137.247,
    r: 3,
    fill: "#EAECF0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 91.3711,
    y: 134.247,
    width: 38.3033,
    height: 7,
    fill: "#EAECF0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M135.454 21.269C135.454 19.7503 136.685 18.519 138.204 18.519H189.393C190.911 18.519 192.143 19.7503 192.143 21.269V73.138C192.143 74.6568 190.911 75.888 189.393 75.888H138.204C136.685 75.888 135.454 74.6568 135.454 73.138V21.269Z",
    fill: "white",
    stroke: "#98A2B3",
    strokeWidth: 2.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.322 26.392C140.322 24.7351 141.665 23.392 143.322 23.392H184.265C185.922 23.392 187.265 24.7351 187.265 26.392V60.5314C187.265 62.1882 185.922 63.5314 184.265 63.5314H143.322C141.665 63.5314 140.322 62.1882 140.322 60.5314V26.392Z",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 138.967,
    y: 24.0724,
    width: 38.3033,
    height: 7,
    fill: "#EAECF0"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.271,
    cy: 27.0724,
    r: 3,
    fill: "#EAECF0"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.967,
    cy: 39.9331,
    r: 3,
    fill: "#EAECF0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 148.967,
    y: 36.9331,
    width: 38.3033,
    height: 7,
    fill: "#EAECF0"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 138.967,
    y: 49.7937,
    width: 38.3033,
    height: 7,
    fill: "#EAECF0"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.271,
    cy: 52.7937,
    r: 3,
    fill: "#EAECF0"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.967,
    cy: 65.6544,
    r: 3,
    fill: "#EAECF0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 148.967,
    y: 62.6544,
    width: 38.3033,
    height: 7,
    fill: "#EAECF0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M142.148 86.2366C142.148 84.7178 143.38 83.4866 144.898 83.4866H196.087C197.606 83.4866 198.837 84.7178 198.837 86.2366V138.106C198.837 139.624 197.606 140.856 196.087 140.856H144.898C143.38 140.856 142.148 139.624 142.148 138.106V86.2366Z",
    fill: "white",
    stroke: "#98A2B3",
    strokeWidth: 2.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.017 91.3595C147.017 89.7026 148.36 88.3595 150.017 88.3595H190.959C192.616 88.3595 193.959 89.7026 193.959 91.3595V125.499C193.959 127.156 192.616 128.499 190.959 128.499H150.017C148.36 128.499 147.017 127.156 147.017 125.499V91.3595Z",
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 145.66,
    y: 89.0398,
    width: 38.3033,
    height: 7,
    fill: "#EAECF0"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.964,
    cy: 92.0398,
    r: 3,
    fill: "#EAECF0"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.66,
    cy: 104.901,
    r: 3,
    fill: "#EAECF0"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 155.66,
    y: 101.901,
    width: 38.3033,
    height: 7,
    fill: "#EAECF0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 145.66,
    y: 114.761,
    width: 38.3033,
    height: 7,
    fill: "#EAECF0"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.964,
    cy: 117.761,
    r: 3,
    fill: "#EAECF0"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.66,
    cy: 130.622,
    r: 3,
    fill: "#EAECF0"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 155.66,
    y: 127.622,
    width: 38.3033,
    height: 7,
    fill: "#EAECF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3451_46204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.754 29.3605L124.47 32.0772L123.198 32.4436L122.028 33.6138L121.771 35.2291L118.602 32.0597L120.217 31.8027L121.387 30.6325L121.754 29.3605Z",
    fill: "#667085",
    stroke: "#667085",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5 36.5001L119.834 33.3333L120.5 34.1667L117.5 36.5001Z",
    fill: "#667085",
    stroke: "#667085",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3451_46204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.754 94.3605L130.47 97.0772L129.198 97.4436L128.028 98.6138L127.771 100.229L124.602 97.0597L126.217 96.8027L127.387 95.6325L127.754 94.3605Z",
    fill: "#667085",
    stroke: "#667085",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.5 101.5L125.834 98.3333L126.5 99.1667L123.5 101.5Z",
    fill: "#667085",
    stroke: "#667085",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3451_46204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.754 86.3605L195.47 89.0772L194.198 89.4436L193.028 90.6138L192.771 92.2291L189.602 89.0597L191.217 88.8027L192.387 87.6325L192.754 86.3605Z",
    fill: "#667085",
    stroke: "#667085",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.5 93.5001L190.834 90.3333L191.5 91.1667L188.5 93.5001Z",
    fill: "#667085",
    stroke: "#667085",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_3451_46204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.754 22.3605L188.47 25.0772L187.198 25.4436L186.028 26.6138L185.771 28.2291L182.602 25.0597L184.217 24.8027L185.387 23.6325L185.754 22.3605Z",
    fill: "#667085",
    stroke: "#667085",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.5 29.5001L183.834 26.3333L184.5 27.1667L181.5 29.5001Z",
    fill: "#667085",
    stroke: "#667085",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3451_46204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(117 29)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3451_46204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(123 94)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3451_46204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(188 86)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_3451_46204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(181 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMultiChat);
export default __webpack_public_path__ + "static/media/emptyMultiChat.f3e9331e6709190232c030363c01840d.svg";
export { ForwardRef as ReactComponent };